import { Navigate } from "react-router-dom";
import MerchantFees from "src/pages/merchant-fees/MerchantFees";
import PrivacyPolicy from "src/pages/privacy-policy/PrivacyPolicy";
import TermsOfService from "src/pages/terms-of-service/TermsOfService";

const routesForPublic: any = [
    {
      path: "privacy",
      element: <PrivacyPolicy />,
    },
    {
      path: "privacy-policy",
      element: <Navigate to="/privacy/" replace />,
    },
    {
      path: "terms",
      element: <TermsOfService />,
    },
    {
      path: "terms-of-service",
      element: <Navigate to="/terms/" replace />,
    },
    {
      path: "merchant-fees",
      element: <MerchantFees />,
    },
    // {
    //   path: "*",
    //   element: <NotFound/>
    // },
  ];

export default routesForPublic;
